// @flow

import * as React from 'react';

import { useParams } from 'react-router-dom';
import { compose } from 'redux';

import { withPageMeta } from '@gandi/app-runner';
import { useTranslator } from '@gandi/translate';

import { Base } from '@gandi/ui';
import { Action, TitleCell, ListItem, ListRow } from '@gandi/ui/deprecated';

import { CallToAction } from '../Overview/components/CallToAction';
import { Layout } from '../components/Layout';
import { useAppSelector } from '../hooks/useAppSelector';
import { selectOrderUrl } from '../modules/config';

export type Params = {
  orderId: string,
};

const marginBottom = { marginBottom: '1px' };

function AwaitingPayment() {
  const { __ } = useTranslator();
  const params = useParams<Params>();
  const orderUrl = useAppSelector(state =>
    selectOrderUrl(state, { orderId: params.orderId }),
  );

  return (
    <Layout currentStep={4}>
      <Base marginBottom="base">
        <ListRow separatorBottom>
          <ListItem>
            <TitleCell>{__('Your order is now awaiting payment')}</TitleCell>
          </ListItem>
        </ListRow>
        <Base
          padding="small"
          backgroundColor="surface"
          separatorTop
          style={marginBottom}
        >
          <Base tagName="p" marginTop="none">
            {__('Your order is now accessible in the billing section.')}
          </Base>
          <Base tagName="p" margin="none">
            {__(
              'If this order contains domain names, note that no operation ' +
                '(create/renew/restore/transfer) can be launched until your payment is effective.',
            )}
          </Base>
        </Base>
        <ListRow>
          <Action variant="block" icon="chevronRight" href={orderUrl}>
            {__('View order')}
          </Action>
        </ListRow>
      </Base>
      <CallToAction />
    </Layout>
  );
}

export default (compose(
  withPageMeta(args => ({
    title: args.__('Order awaiting payment - Gandi.net'),
  })),
)(AwaitingPayment): React.ComponentType<{}>);
